const MOVE_OBJECT = 'move_object';
const SELECTION_TOGGLE = 'selection_toggle';
const PURCHASE_STATUS_CHANGE = 'purchase_status';
const PROPS_CHANGED = 'props_changed';

export {
    MOVE_OBJECT,
    SELECTION_TOGGLE,
    PURCHASE_STATUS_CHANGE,
    PROPS_CHANGED,
};
